import PasscodeInput from "@/features/auth/components/PasscodeInput";
import { useParams } from "react-router";

/**
 * Interactive Survey Login Modal
 * Based on documentation requirements:
 * - 320x320px centered modal
 * Handles both single-survey (:surveyId) and survey-group (:surveyGroupId) routes.
 */
const InteractiveSurveyLogin = () => {
  const { surveyId, surveyGroupId } = useParams<{
    surveyId?: string;
    surveyGroupId?: string;
  }>();

  if (!surveyId && !surveyGroupId) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl w-80 h-80 flex flex-col items-center justify-center p-6">
          <div className="text-red-600 text-center">
            <h2 className="text-lg font-semibold mb-2">Error</h2>
            <p className="text-sm">
              Survey ID is required to access this content.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div
        style={{ border: "1px solid #e0e0e0", padding: "2rem 1rem" }}
        className="rounded-lg shadow-md w-90 flex flex-col items-center justify-center"
      >
        <h2 className="passcode-header">Enter Passcode</h2>
        <p>This document is locked.</p>
        <p>Please enter the passcode below.</p>

        <PasscodeInput surveyId={surveyId} surveyGroupId={surveyGroupId} />

        <div className="mt-4 text-center">
          <p>
            If you don&apos;t know the code, ask the person who sent you this
            link.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InteractiveSurveyLogin;

